import { InjectionToken } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import type { PushNotificationsPlugin } from '@capacitor/push-notifications';

export const PUSH_NOTIFICATIONS_INJECTION_TOKEN = new InjectionToken<PushNotificationsPlugin>(
  'PushNotificationsPlugin'
);

export function providePushNotifications() {
  return {
    provide: PUSH_NOTIFICATIONS_INJECTION_TOKEN,
    useValue: PushNotifications,
  };
}
